import Swiper from "swiper";
// import { Pagination, Navigation } from "swiper";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(() => {
  const swiperArticle = new Swiper(".swiper.swiper__articles", {
    modules: [Pagination, Navigation],
    spaceBetween: 20,
    slidesPerView: "auto",
    pagination: {
      el: ".swiper__articles .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper__articles .swiper-button-next",
      prevEl: ".swiper__articles .swiper-button-prev",
    },
    breakpoints: {
      1400: {
        spaceBetween: 40,
        slidesPerView: "auto",
      },
    },
  });

  sharingFixed();

  $(".social-button-fb").click(function () {
    const forShareUrl = window.location.origin + window.location.pathname;
    const baseUrl = "https://www.facebook.com/sharer.php?u=";
    const completeUrl = baseUrl + forShareUrl;

    window.open(completeUrl, "_blank");
  });

  $(".social-button-line").click(function () {
    const forShareUrl = window.location.origin + window.location.pathname;
    let baseUrl;
    let completeUrl;

    if ($(this).hasClass("mb-share")) {
      baseUrl = "https://line.me/R/msg/text/?";
      completeUrl = baseUrl + forShareUrl;
    } else {
      baseUrl = "https://social-plugins.line.me/lineit/share?url=";
      completeUrl = baseUrl + forShareUrl;
    }

    window.open(completeUrl);
  });

  $(".social-button-link").click(function () {
    navigator.clipboard.writeText(
      window.location.origin + window.location.pathname
    );
  });
});

const pinEl = document.querySelector(".pin");
const sharingFixed = () => {
  if (pinEl) {
    const el = document.querySelector(".article-main");

    let mm = gsap.matchMedia();
    mm.add("(min-width: 1200px)", () => {
      ScrollTrigger.create({
        trigger: el,
        endTrigger: ".article-others",
        pin: ".pin",
        pinSpacing: false,
        start: "top top",
        end: "top bottom",
      });
    });
  }
};
document.addEventListener('DOMContentLoaded', (event) => {
  document.body.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    // alert('右鍵被禁用');
  });
});